import { ICountriesReducer, ICountry } from 'models/Country'
import { Action } from 'redux'
import { isType } from 'ts-action'
import { updateArray } from 'helpers/helperFunctions'
import { GetCountries, CountriesFetching, UpdateCountry, UpdateCountryId } from './actions'

const initialState: ICountriesReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const countriesReducer = (state = initialState, action: Action): ICountriesReducer => {
  if (isType(action, GetCountries)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }
  if (isType(action, UpdateCountry)) {
    const { payload } = action
    const { data } = state
    const formattedArray = updateArray<ICountry>(data, payload.data)
    return {
      ...state,
      data: formattedArray,
    }
  }
  if (isType(action, CountriesFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  if (isType(action, UpdateCountryId)) {
    const { payload } = action
    return {
      ...state,
      countryId: payload,
    }
  }
  return state
}
